import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureSection from './components/FeatureSection';
import SeoArticleSection from './components/SeoArticleSection';
import ArticleCardsSection from './components/ArticleCardsSection';
import TestimonialSection from './components/TestimonialSection';
import CtaSection from './components/CtaSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://oopbuyspread.click';
const siteName = 'Oopbuy Spreadsheet Deutschland';
const siteDesc = 'Der ultimative Oopbuy Spreadsheet Guide für Deutschland 2026';

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": siteName,
  "url": siteUrl,
  "description": siteDesc,
  "email": "support@oopbuyspread.click",
  "inLanguage": "de",
  "areaServed": { "@type": "Country", "name": "Deutschland" },
  "foundingDate": "2024"
};

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": siteName,
  "url": siteUrl,
  "description": siteDesc,
  "inLanguage": "de",
  "publisher": {
    "@type": "Organization",
    "name": "Oopbuy Spreadsheet"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }} />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <FeatureSection />
      <SeoArticleSection />
      <ArticleCardsSection />
      <TestimonialSection />
      <CtaSection />
      <Footer />
    </main>
  );
}